import * as z from "zod";

const conversationSourceSchema = z.object({
  topicId: z.string(),
  hasSupportTicket: z.boolean(),
  hasCommerceAgentConversation: z.boolean(),
  campaignId: z.string().nullable(),
  automationId: z.string().nullable(),
  automationStepId: z.string().nullable(),
  primaryTriggerKey: z.string().nullable(),
});

export type ShopperAgentConversationSource = z.infer<
  typeof conversationSourceSchema
>;

/**
 * Where a conversation came from and where it lives in the merchant app: one
 * entry per support, Commerce Agent or outreach topic on the channel thread.
 */
export const getShopperAgentConversationSources = {
  name: "getShopperAgentConversationSources" as const,
  input: z.object({ channelThreadId: z.string() }),
  output: z.object({
    teamId: z.string(),
    sources: z.array(conversationSourceSchema),
  }),
};

export type GetShopperAgentConversationSourcesOutput = z.infer<
  typeof getShopperAgentConversationSources.output
>;
